import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { stockService } from "@/services/stock";

import { useMe } from "./use-auth";

export function useRiderStocks(workspaceId?: string) {
  const { data: me } = useMe();
  const wsId = workspaceId ?? me?.workspaceId;

  return useQuery({
    queryKey: queryKeys.stocks.riders(wsId),
    queryFn: () =>
      stockService.riders(wsId ? { workspace_id: wsId } : undefined),
  });
}
